<template>
  <div class="box7">
    <pageTitle
      title="强强联合&nbsp;&nbsp;企业级真项目"
      text="与大厂共建资源库，培育出市场真正需要的AI人才"
    />

    <div class="subject-content">
      <swiper :options="swiperOption" ref="mySwiper" class="swiperitems">
        <swiper-slide
          class="swiperwrap"
          v-for="(item, index) in list"
          :key="index"
        >
          <div class="block">
            <img
              :src="
                require(`../../../assets/coursePage/ai/box7/${index + 1}.png`)
              "
              alt
            />
            <div class="title">{{ item.title }}</div>
            <p>{{ item.p }}</p>
          </div>
        </swiper-slide>
      </swiper>
      <div class="swiper-pagination-box7"></div>
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  components: {
    pageTitle,
    swiper,
    swiperSlide,
  },
  mounted() {},
  data() {
    return {
      swiperOption: {
        loop: true, // 循环模式选项
        slidesPerView: "auto",
        centeredSlides: true,
        // paginationClickable: true,
        spaceBetween: 40,
        // effect: "left",
        pagination: {
          el: ".swiper-pagination-box7",
        },
      },
      list: [
        {
          title: "百度云智学院，制定人工智能人才培养方案",
          p: "百度云与传智教育双方共同制定和推广“人工智能”人才标准及人才培养方案，并根据各自的优势共同进行课程设计和优化，旨在培养更专业的人工智能领域人才。",
        },
        {
          title: "京东人工智能平台，达成AI项目资源深度合作",
          p: "京东与传智教育双方通过平台建设、课程研发、人才培养及产品创新。围绕人工智能数据科学、图像与视觉处理、自然语言处理等领域开展更多深度合作。",
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.box7 {
  padding: 80px 0 88px;
  width: 100%;
  background: url("../../../assets/coursePage/ai/box7/bg.png") no-repeat;
  background-size: cover;
  .subject-content {
    position: relative;
    margin-top: 48px;
    width: 100%;
    box-sizing: border-box;
  }

  .swiper-slide {
    margin-bottom: 38px;
    padding: 40px;
    width: 686px;
    height: 614px;
    background: rgba(255, 255, 255, 0.5);
    box-shadow: 4px 8px 30px 0px rgba(163, 195, 213, 0.34);
    border: 2px solid #ffffff;
    // backdrop-filter: blur(5px);
    box-sizing: border-box;
    border-radius: 20px;

    img {
      margin-bottom: 40px;
      width: 606px;
      height: 306px;
    }

    .title {
      margin-bottom: 16px;
      font-size: 28px;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      color: #1d2129;
      line-height: 40px;
    }

    p {
      font-size: 24px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 44px;
    }
  }

  .swiper-pagination-box7 {
    display: flex;
    align-items: center;
    position: absolute;
    left: 50%;
    bottom: 0px;
    transform: translate(-50%, 0px);
    height: 6px;
    border-radius: 3px;
    background: rgba(46, 165, 252, 0.16);
    // background: rgba(46, 165, 252, 0.16);
    // border-radius: 3px;
  }

  /deep/ .swiper-pagination-bullet {
    width: 20px;
    height: 6px;
    background: rgba(46, 165, 252, 0.16);
    border-radius: 3px;
  }

  /deep/.swiper-pagination-bullet.swiper-pagination-bullet-active {
    width: 20px;
    height: 6px;
    background: #2ea5fc;
    border-radius: 3px;
  }
}
</style>
